import { render, staticRenderFns } from "./OrganismConfigurationHistory.vue?vue&type=template&id=4a36bb81&scoped=true&"
import script from "./OrganismConfigurationHistory.vue?vue&type=script&lang=js&"
export * from "./OrganismConfigurationHistory.vue?vue&type=script&lang=js&"
import style0 from "./OrganismConfigurationHistory.vue?vue&type=style&index=0&id=4a36bb81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a36bb81",
  null
  
)

export default component.exports